import React from 'react'
import { Form, Input, Button, } from 'antd'
import './register'
import api from '../../api/api.js'
import {API_CONFIG} from '../../api/config.js'

class CreateGroup extends React.Component {
    state = {
        loading: false
    }

    handleSubmit = () => {
        console.log(sessionStorage.getItem('source')==='undefined'?'cgj':sessionStorage.getItem('source'))
        this.props.form.validateFields((err, values, callback) => {
            if (err) return;
            this.setState({
                loading: true
            })
            api.create_group({
                name: values.group_name || '',
                user_name:values.user_name || '',  //用户名
                source: sessionStorage.getItem('source')==='undefined'?'cgj':sessionStorage.getItem('source'),
                access_token: sessionStorage.getItem('access_token')
            }).then(res => {
                this.setState({
                    loading: false
                })
                if (res.code === 0) {
                    api.get_company_login({
                        access_token: sessionStorage.getItem('access_token'),
                        corp_uuid:res.content.corp_uuid,
                        source: sessionStorage.getItem('source')==='undefined'?'cgj':sessionStorage.getItem('source'),
                    }).then(res=>{
                        if(res.code===0){
                            sessionStorage.setItem('company_token',res.content.access_token)
                            document.cookie= `${API_CONFIG.cloud_token}=${res.content.access_token};domain=colourlife.com;;path=/;`
                            if(sessionStorage.getItem('market_url')){
                                let market_url = sessionStorage.getItem('market_url')
                                window.location.href=`${market_url}`
                            } else {
                                window.location.href=`${API_CONFIG.yun_base}`
                            }
                        }
                    })
                }
            }).catch(err => {
                this.setState({
                    loading: false
                })
            })
        })
      
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        return (
            <div>
                <Form >
                <Form.Item label="创建用户" className='item'>
                {getFieldDecorator('user_name', {
                    rules: [{ required: true, message: '请设置用户名' }],
                })(<Input placeholder='请设置用户名' />)}
                </Form.Item>
                <Form.Item label="创建公司" className='item'>
                {getFieldDecorator('group_name', {
                    rules: [{ required: true, message: '请设置公司名称' }],
                })(<Input placeholder='请设置公司名称' />)}
                </Form.Item>
                <Button type='primary' className='register-btn' onClick={this.handleSubmit} style={{marginTop: 134}} loading={this.state.loading}>完成注册</Button>
                </Form>
                
            </div>
        )
    }
}
export default Form.create({})(CreateGroup);


// WEBPACK FOOTER //
// ./src/pages/register/CreateGroup.jsx